import * as z from "zod";

export const getShippingMetrics = {
  name: "getShippingMetrics" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    canonicalLocationExternalId: z.string().optional(),
  }),
  output: z.object({
    shipmentErrorRate: z.number(),
    avgTimeToDelivery: z.number(),
    claimsRate: z.number(),
    topClaimsReason: z.string(),
  }),
};
